require('../css/main.scss');
require('../css/about.scss');

const mobileMenu = require('./func/mobile-menu');

window.addEventListener('DOMContentLoaded', run);

async function run(e) {
    console.log('About page');
    mobileMenu('.c-mobile-menu', '.c-mobile-menu_button');
}
